export default __webpack_public_path__ + "static/media/Edit.fe7c1712.svg";